"use client";

import createSvgIcon from "./utils/createSvgIcon.mjs";
import { jsx as _jsx } from "react/jsx-runtime";
export default createSvgIcon(/*#__PURE__*/_jsx("path", {
  d: "M8 23h8v-2H8zM18 1.01 6 1v18h12zM16 15H8V5h8z"
}), 'DockSharp');